import { LevelSettings, MiscSettings } from "../settings/Settings";
import { YoutubeStorageManager } from "./storage/YoutubeStorageManager";
export var LevelRandomiser = function () {
    "use strict";
    this._isInitialized = false;
    this._playHistory = false;
};
LevelRandomiser.prototype.SelectRandomLevel = function (limitedLevels) {
    "use strict";
    // Get a list of all the levels
    var levels = [];
    for (var i = 0; i < LevelSettings.levelList.length; i++) {
        levels[i] = i;
    }
    // Iterate over levels played, and if played remove them from the array
    for (var i = levels.length - 1; i >= 0; i--) {
        if (this._playHistory.indexOf(i) != -1 || (limitedLevels && limitedLevels.indexOf(i) == -1) || (LevelSettings.nonRandomLevels.indexOf(i) != -1 && !limitedLevels)) {
            levels.splice(i, 1);
        }
    }
    // If the array is empty, then we need to reinit
    if (levels.length == 0) {
        this._resetData();
        return this.SelectRandomLevel(limitedLevels);
    }
    return levels[Math.floor(Math.random() * levels.length)];
};
LevelRandomiser.prototype._resetData = function () {
    "use strict";
    this._playHistory = [];
    this._syncPlayHistory();
};
LevelRandomiser.prototype.initialize = function (callback) {
    "use strict";
    var self = this;
    YoutubeStorageManager.getPlayerData(["playHistory"], function (data) {
        var playHistory = data["playHistory"];
        if (!playHistory) {
            // initialize playHistory for the first time
            self._playHistory = [];
        }
        else {
            if (playHistory.length > MiscSettings.playHistorySize) {
                console.log("Mismatch size! Playhistory was too long");
                self._resetData();
            }
            else if (!(playHistory instanceof Array)) {
                console.log("Playhistory had the wrong type");
                self._resetData();
            }
            else {
                self._playHistory = playHistory;
            }
        }
        self._isInitialized = true;
        if (callback) {
            callback();
        }
    });
};
// Send play history to the server
LevelRandomiser.prototype._syncPlayHistory = function () {
    "use strict";
    var self = this;
    YoutubeStorageManager.savePlayerData(["playHistory"], [self._playHistory], function () { }, function (error) {
        console.error("Error while saving LevelRandomiser data on Server");
    });
};
LevelRandomiser.prototype.AddLevelToPlayHistory = function (levelIndex) {
    "use strict";
    this._playHistory.push(levelIndex);
    if (this._playHistory.length >= MiscSettings.playHistorySize) {
        this._playHistory = [];
    }
    this._syncPlayHistory();
};
